var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.564 13.558a1.505 1.505 0 000-2.12 1.506 1.506 0 00-2.12 0L23.002 23.883l-7.943-7.942a1.506 1.506 0 00-2.12 0L2.437 26.442a1.506 1.506 0 000 2.12 1.506 1.506 0 002.12 0l9.442-9.443 7.943 7.942a1.506 1.506 0 002.12 0l13.503-13.503z"
  })));
}

export default SvgLine;